import { Localized } from "@fluent/react"
import { Chip } from "@mui/material"
import { DeviationClassification, DeviationStatus } from "./deviationsApi"
import LockIcon from '@mui/icons-material/Lock';

export const ClassificationChip = (props: { value: DeviationClassification }) => {
    const { value } = props
    switch (value) {
        case 'MINOR':
            return <Chip color='success' label={<Localized id='deviation-classification-minor'>
                Drobne
            </Localized>} />
        case 'MAJOR':
            return <Chip color='warning' label={<Localized id='deviation-classification-major'>
                Ważne
            </Localized>} />
        case 'CRITICAL':
            return <Chip color='error' label={<Localized id='deviation-classification-critical'>
                Krytyczne
            </Localized>} />
    }
}

export const StatusChip = (props: { status: DeviationStatus }) => {
    let title = <></>
    switch (props.status) {
        case 'NEW':
            title = <Localized id='deviation-status-new'>Nowe</Localized>
            break
        case 'ANALYZED':
            title = <Localized id='deviation-status-analyzed'>Analiza</Localized>
            break
        case 'EVALUATED':
            title = <Localized id='deviation-status-evaluated'>Ocena</Localized>
            break
        case 'CORRECTED':
            title = <Localized id='deviation-status-corrected'>Działania naprawcze</Localized>
            break
        case 'CLOSED':
            return <Chip variant='outlined' icon={<LockIcon fontSize="small" />} label={<Localized id='deviation-status-closed'>Zamknięte</Localized>} />
    }
    return <Chip variant='outlined' color="info" label={title} />
}
